export * from './map-field.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/form/fields/map-field/index.ts